// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1831":"ca8d182d","1838":"8a26378c","5618":"ca8d182d"}[chunkId] + ".chunk.css";
};